import React, { Fragment } from "react";
import Link from "next/link";
import Head from "next/head";
import styles from "@/styles/lustcollection.module.scss";
import { homeLinks } from "@/data/home";
const LustCollection = () => {
  return (
    <Fragment>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(homeLinks.lustCollection.schema),
          }}
        />
      </Head>
      <section>
        <div className={styles.videoResponsive}>
          <div className="row">
            <div
              className={styles.video_cotainer}
              dangerouslySetInnerHTML={{
                __html: homeLinks.lustCollection.youtube_iframe,
              }}
            ></div>
          </div>
        </div>
      </section>
      {/* <div className="container">
        <div className="col-md-12 text-center">
          <Link href={homeLinks.lustCollection.link} passHref>
            <a className={styles.btn_get_started}>View All Collections</a>
          </Link>
        </div>
      </div> */}
    </Fragment>
  );
};

export default LustCollection;
